// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3Tg-h","buttons":"PendingPaymentAlert_buttons__2G8cw"};